export enum UserStatusEnums {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  DEACTIVATED = 'DEACTIVATED',
}
